<script lang="ts">
  import { get } from 'svelte/store'
  import { isLoggingInProcessStore, fn, pageStore, clientPublicStore } from '@packages/stores'
  import { configStore, forcedPage } from '@src/stores'
  import { onDestroy } from 'svelte'
  import { Login } from '@packages/ui'
  import { AUTH_PROVIDERS, PassportLocalStorage } from '@packages/utils/enums'
  import { generate } from 'lean-qr'
  import { toSvgSource } from 'lean-qr/extras/svg'
  import { getAvailableLoginMethods } from './authMethods.helper'
  import Loader from '@packages/ui/main/shared/Loader.svelte'

  const cachedQr = localStorage.getItem(PassportLocalStorage.QR_CODE)
  let qrCodeSvg: string
  const showQr = () => {
    if (!cachedQr) return
    const qrData = JSON.parse(cachedQr)
    const code = generate(JSON.stringify(qrData))
    qrCodeSvg = toSvgSource(code, { width: 250, height: 250 })
  }
  const hideQr = () => (qrCodeSvg = '')

  let config = get(configStore)
  let isLoading: boolean = false

  const { login, close } = get(fn)

  const handleLogin = async ({ provider }: { provider: AUTH_PROVIDERS }) => {
    try {
      isLoading = true
      await login(provider)
      isLoading = false
      if (!$forcedPage && !$pageStore) close()
    } catch (err) {
      isLoading = false
    }
  }

  const authTitle = config.content?.auth?.title ?? 'Let’s get started'
  const authDescription = config.content?.auth?.description ?? 'Confirm your account to connect.'

  const loginIndicatorSub = isLoggingInProcessStore.subscribe((val) => (isLoading = val))

  onDestroy(loginIndicatorSub)

  const loginMethods = getAvailableLoginMethods()
</script>

{#if $clientPublicStore}
  <Login
    options={{
      isLoading,
      authTitle,
      authDescription,
      qrOptions: {
        qrCodeSvg,
        showQr,
        hideQr,
      },
      authOptions: {
        loginMethods,
        handleLogin,
      },
    }}
  />
{:else}
  <Loader />
{/if}
